import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-raging',
  templateUrl: './raging.component.html',
  styleUrls: ['./raging.component.scss']
})
export class RagingComponent implements OnInit {

  src: string = '/assets/pdf/Anti Ragging Cell.pdf';
  constructor() { }

  ngOnInit(): void {
  }

}
